export enum DownloadFormat {

    gridNetCdf,
    gridGeoTiff,
    gridEsriAscii,
    sidNetCdf,
    sidGeoTiff,
    sidEsriAscii,
    colorJpeg,
    colorPng,
    shadedReliefJpeg,
    shadedReliefPng,
}


